import { render, staticRenderFns } from "./DrawerMenuFerramentas.vue?vue&type=template&id=5d40142c&lang=pug"
import script from "./DrawerMenuFerramentas.vue?vue&type=script&lang=js"
export * from "./DrawerMenuFerramentas.vue?vue&type=script&lang=js"
import style0 from "./DrawerMenuFerramentas.vue?vue&type=style&index=0&id=5d40142c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports